<p><button mat-button (click)="clear()">clear()</button></p>
<p><button mat-button (click)="getSelectedRefineryDetails()">getSelectedRefineryDetails()</button></p>
<p><button mat-button (click)="getSelectedNodeDetails()">getSelectedNodeDetails()</button></p>
<p><button mat-button (click)="getSelectedConfigJson()">getSelectedConfigJson()</button></p>
<p><button mat-button (click)="getSelectedTabIndex()">getSelectedTabIndex()</button></p>
<p><button mat-button (click)="getNodeParentDataLine()">getNodeParentDataLine()</button></p>
<p><button mat-button (click)="getNodeAttributionLine()">getNodeAttributionLine()</button></p>
<p><button mat-button (click)="getMasterNodeBoxTypes()">getMasterNodeBoxTypes()</button></p>
<p><button mat-button (click)="getMasterTransformers()">getMasterTransformers()</button></p>
<p><button mat-button (click)="getMasterFarmtypes()">getMasterFarmtypes()</button></p>
